import axios from 'axios';
import { API_BASE_URL } from '../config';

/**
 * Centralized API client with base URL and error handling.
 */
const api = axios.create({
  baseURL: API_BASE_URL.replace(/\/$/, ''),
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Get error message from API response or fallback.
 */
export function getErrorMessage(err, fallback = 'Something went wrong. Please try again.') {
  if (!err) return fallback;
  const data = err.response?.data;
  const messages = [data?.error, data?.message, ...(Array.isArray(data?.details) ? data.details : [])];
  const message = messages.find((value) => typeof value === 'string' && value.trim());
  if (message) return message;

  if (!err.response) {
    if (err.code === 'ECONNABORTED' || err.code === 'ETIMEDOUT') {
      return 'The server is taking too long to respond. Please wait a moment and try again.';
    }
    if (err.code === 'ERR_NETWORK' || err.request || err.message === 'Network Error') {
      return 'Unable to connect to the server. Please check your connection and try again.';
    }
  }
  return fallback;
}

export default api;
